import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import Features from "../../SettingsApp/Plan/PlanSettings/Features";
import { PlanSelector } from "../../SettingsApp/Plan/PlanSettings/PlanSelector";
import { BillingCurrency } from "../../SettingsApp/Plan/RegularPlan/BillingCurrency";
import { BillingCycle } from "../../SettingsApp/Plan/RegularPlan/BillingCycle";

export const ControlVariantBody = () => (
  <div className="mx-auto max-w-[960px]">
    <div className="flex flex-row flex-wrap items-center justify-between">
      <Typography.TitleSm weight="semibold">
        {t("pricing_plans.plans_modal.title")}
      </Typography.TitleSm>

      <div className="flex items-center">
        <BillingCurrency />
        <BillingCycle />
      </div>
    </div>
    <div className="mt-6">
      <PlanSelector />
    </div>
    <div className="mt-12">
      <Features />
    </div>
  </div>
);
